export default __webpack_public_path__ + "static/media/img13.7f456366.png";